"use strict";
/*
Example usage:

import { getIdToken, getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

const api = buildApi({
  // TODO: Fill these in with the actual endpoints
  fetchMap: {
    "artist.resolver": "",
    "artist.start": "",
    "search.streaming": "",
    "search.youtube": "",
  },
  getToken: async () => {
    const auth = getAuth();
    if (auth.currentUser) {
      return getIdToken(auth.currentUser);
    }

    console.warn(
      "An attempt is being made to call an API endpoint before we have an authenticated user",
    );

    return "";
  },
  httpsCallable: (name) => httpsCallable(getFunctions(), name),
});

api.call("setlivev3-analysis-analyzeImageFromURL", { url: "" }).then((res) => {
  res.data.colors;
});

api.call("artist.resolver", { url: "" }).then((res) => {
  if (res.data.success) {
    res.data.data.displayName;
  }
});
*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApi = exports.admin = exports.ErrorCodes = void 0;
const base_1 = require("./base");
Object.defineProperty(exports, "ErrorCodes", { enumerable: true, get: function () { return base_1.ErrorCodes; } });
exports.admin = __importStar(require("./admin"));
const buildApi = (props) => {
    const isFetchable = (key) => key in props.fetchMap;
    const call = async (name, body, options) => {
        if (isFetchable(name)) {
            const url = props.fetchMap[name];
            if (!url) {
                throw new Error(`API is missing route to endpoint ${name}`);
            }
            const token = await props.getToken().catch((error) => {
                console.warn("Error getting JWT for user", error);
            });
            const req = new Request(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: body !== undefined ? JSON.stringify(body) : "",
            });
            if (token) {
                req.headers.set("Authorization", `bearer ${token}`);
            }
            const data = await fetch(req, {
                signal: options === null || options === void 0 ? void 0 : options.signal,
            })
                .then((res) => res.json())
                .then((data) => ({ data }));
            return data;
        }
        return (await props.httpsCallable(name)(body));
    };
    return { call };
};
exports.buildApi = buildApi;
//# sourceMappingURL=index.js.map